const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const HealEvent = require('../../events/HealEvent');
const { logError } = require('../../logger');

const Suture = function (battleState) {
  this.handle = 'suture';
  this.physical = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);
      let remaining_suture_potency = ability.potency;

      // decrement potency of bleeding conditions until all of ability potency is used
      const bleeding_conditions = BattleCalc.getAllBleedConditions(victim);
      for (const bc of bleeding_conditions) {
        const bleed_potency_buf = bc.potency;
        bc.potency -= remaining_suture_potency;
        remaining_suture_potency -= bleed_potency_buf;
        if (bc.potency <= 0) battleState.expireCondition(bc.uid);
        else battleState.updateCondition(victim.uid, bc.uid);

        if (remaining_suture_potency <= 0) break;
      }

      // apply healing
      const healEvent = new HealEvent(battleState, actor, ability.healing);
      healEvent.execute(victim);

      var result = { healEvent };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;

      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Suture',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Suture;
